export const NOTIFICATIONS_LOADING = '@@reservble/app/notification/NOTIFICATIONS_LOADING';
export const SAVE_NOTIFICATIONS = '@@reservble/app/notification/SAVE_NOTIFICATIONS';

export const UNREAD_NOTIFICATIONS_COUNT_LOADING = '@@reservble/app/notification/UNREAD_NOTIFICATIONS_COUNT_LOADING';
export const SAVE_UNREAD_NOTIFICATIONS_COUNT = '@@reservble/app/notification/SAVE_UNREAD_NOTIFICATIONS_COUNT';
